/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchRunResultTotals
 */
export interface BatchRunResultTotals {
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultTotals
     */
    subtotalAmount: number;
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultTotals
     */
    serviceFee: number;
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultTotals
     */
    totalPayoutAmount: number;
    /**
     * 
     * @type {number}
     * @memberof BatchRunResultTotals
     */
    ordersCount: number;
}

/**
 * Check if a given object implements the BatchRunResultTotals interface.
 */
export function instanceOfBatchRunResultTotals(value: object): value is BatchRunResultTotals {
    if (!('subtotalAmount' in value) || value['subtotalAmount'] === undefined) return false;
    if (!('serviceFee' in value) || value['serviceFee'] === undefined) return false;
    if (!('totalPayoutAmount' in value) || value['totalPayoutAmount'] === undefined) return false;
    if (!('ordersCount' in value) || value['ordersCount'] === undefined) return false;
    return true;
}

export function BatchRunResultTotalsFromJSON(json: any): BatchRunResultTotals {
    return BatchRunResultTotalsFromJSONTyped(json, false);
}

export function BatchRunResultTotalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchRunResultTotals {
    if (json == null) {
        return json;
    }
    return {
        
        'subtotalAmount': json['subtotal_amount'],
        'serviceFee': json['service_fee'],
        'totalPayoutAmount': json['total_payout_amount'],
        'ordersCount': json['orders_count'],
    };
}

export function BatchRunResultTotalsToJSON(json: any): BatchRunResultTotals {
    return BatchRunResultTotalsToJSONTyped(json, false);
}

export function BatchRunResultTotalsToJSONTyped(value?: BatchRunResultTotals | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subtotal_amount': value['subtotalAmount'],
        'service_fee': value['serviceFee'],
        'total_payout_amount': value['totalPayoutAmount'],
        'orders_count': value['ordersCount'],
    };
}

